import React, { useEffect } from "react";
import {
  Paper,
  Grid,
  IconButton,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  Divider,
  Container,
  Box,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import MySearch from "../../components/MySearch/MySearch";
import MyPagination from "../../UI/Pagination/Pagination";
import MySort from "../../components/MySearch/MySort";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import AxiosErrorHandling from "../../components/AxiosErrorHandling/AxiosErrorHandling";
import CachedRoundedIcon from "@material-ui/icons/CachedRounded";
import Spinner from "../../UI/Skeletons/JobsSkeleton";
import SingleCompany from "./SingleCompany";
import axios from "axios";
import SingleCompanyFullDetails from "./SingleCompanyFullDetails";
import YesNoDialog from "../../components/DialogYesNo/DialogYesNo";
import AddUpdateCompanyManager from "./AddUpdateCompanyManager";
const DRAWER_WIDTH = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 160,
    "& .MuiPaper-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDivider-root": {
      height: 1,
      width: "100%",
      marginTop: theme.spacing(1),
    },
  },
  topSearchBar: {
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    position: "fixed",
    top: 0,
    zIndex: 10,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    width: "calc(100% - " + DRAWER_WIDTH + "px)",
  },
  topHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  refreshButton: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
}));

const getCompanyIndex = (companies, companyId) => {
  return companies.findIndex((comp) => comp.id === companyId);
};

const CompaniesList = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [companies, setCompanies] = React.useState([]);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalCompaneis, setTotalCompanies] = React.useState(1);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  const [companyToUpdate, setCompanyToUpdate] = React.useState(null); //holds a company object from the companies array
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [showSignalTab, setShowSignalTab] = React.useState(false);
  const [rerender, setRerender] = React.useState(false);
  const [signalCategories, setSignalCategories] = React.useState([]);
  const [addMode, setAddMode] = React.useState(false);

  useEffect(() => {
    const fetchCompanies = async () => {
      setIsLoading(true);
      try {
        const companiesData = await axios.get("/wp-json/api/v2/companies", {
          params: {
            page: currentPage,
            extended: true,
          },
        });
        setIsLoading(false);
        setTotalCompanies(parseInt(companiesData.headers["x-wp-total"]));
        setTotalPages(parseInt(companiesData.headers["x-wp-totalpages"]));
        setCompanies(companiesData.data.companies);
        setSignalCategories(companiesData.data.signal_categories);
      } catch (err) {
        setIsLoading(false);
        setError(err.response);
      }
    };
    fetchCompanies();
  }, [currentPage]);

  useEffect(() => {
    setAddMode(props.location.pathname === "/companies/add");
  }, [props.location]);

  const handleRemoveCompany = async () => {
    const deleteId = confirmDelete;
    setConfirmDelete(false); //resetDialog
    const index = companies.findIndex((comp) => comp.id === deleteId);

    try {
      setIsLoading(true);
      const removeCompany = await axios.delete(
        `/wp-json/api/v2/company/${deleteId}`
      );
      setIsLoading(false);
      if (removeCompany) {
        //update list:
        let tempCompanies = companies;
        if (index > -1) {
          //Splice doesn't re-render the component hence I will use filter instead.
          tempCompanies = tempCompanies.filter((comp) => comp.id !== deleteId);
          setCompanies(tempCompanies);
        }
      }
    } catch (err) {
      console.log("ERR", err);
      resetState();
      setError(err.response);
    }
  };

  const handleSaveCompanySignals = async () => {
    const companyIndx = getCompanyIndex(companies, selectedCompany);
    if (companyIndx > -1) {
      const res = await axios.post(
        `/wp-json/api/v2/update_company/${selectedCompany}`,
        {
          signals: companies[companyIndx].signals,
        }
      );
      resetState();
    }
  };

  const handleSelectCompany = (id) => {
    if (companies.find((company) => company.id === id)) setSelectedCompany(id);
  };

  const resetState = () => {
    setSelectedCompany(false);
    setShowSignalTab(false);
    setAddMode(false);
    setIsLoading(false);
    setConfirmDelete(false);
    setCompanyToUpdate(null);
  };

  const handleShowSignalsTab = (id) => {
    //change state to show signals
    setSelectedCompany(id);
    setShowSignalTab(true);
  };

  const handleUpdateCompany = (id) => {
    const companyIndex = getCompanyIndex(companies, id);
    if (companyIndex > -1) {
      //validated
      setCompanyToUpdate(companies[companyIndex]);
      setAddMode(true);
    }
  };

  const handleContactsRemove = async (companyId, contactId) => {
    setRerender((prev) => !prev);
    const tempCompanies = companies;
    const tempCompanyIndex = getCompanyIndex(tempCompanies, companyId);
    if (tempCompanyIndex > -1) {
      const contactIndex = tempCompanies[tempCompanyIndex].contacts.findIndex(
        (contact) => contact.id === contactId
      );
      if (contactIndex > -1) {
        try {
          const tempContactIsPrimary =
            tempCompanies[tempCompanyIndex].contacts[contactIndex].is_primary;
          //delete the contact
          tempCompanies[tempCompanyIndex].contacts.splice(contactIndex, 1);
          const res = await axios.delete(
            `/wp-json/api/v2/company_contact/${contactId}`
          );
          if (res) {
            //check if the person is primary and if there are others
            if (
              tempContactIsPrimary &&
              tempCompanies[tempCompanyIndex].contacts.length >= 1
            ) {
              tempCompanies[tempCompanyIndex].contacts.sort((a, b) =>
                a.id > b.id ? a : b
              );
              tempCompanies[tempCompanyIndex].contacts[0].is_primary = true;
            }
          }
        } catch (err) {
          setError(err.response);
        }
      }
    }

    setCompanies(tempCompanies);
  };

  const handleCloseFullDetails = () => {
    resetState();
  };

  const handleCancelAddCompany = () => {
    resetState();
    props.history.push("/companies");
  };

  const handleUpdateCompanySignals = (signalId, value) => {
    const tempCompanies = companies;
    const tempCompanyIndex = getCompanyIndex(tempCompanies, selectedCompany);
    if (tempCompanyIndex > -1) {
      const { signals } = tempCompanies[tempCompanyIndex];
      if (value) {
        //add new category, check for duplication
        if (!signals.includes(signalId)) {
          tempCompanies[tempCompanyIndex].signals = [...signals, signalId];
        }
      } else {
        //remove from array
        const signalIndex = signals.findIndex((sig) => sig === signalId);
        signals.splice(signalIndex, 1);
      }
      setCompanies(tempCompanies);
    }
    setRerender((prev) => !prev);
  };

  const handleAddCompany = async (companyData, fieldsUpdated = []) => {
    handleCancelAddCompany();

    if (companyData.id > 0) {
      //This is an update call:
      let companyUpdateObj = {};
      if (fieldsUpdated.includes("name"))
        companyUpdateObj = {
          ...companyUpdateObj,
          company_name: companyData.name,
        };
      if (fieldsUpdated.includes("address"))
        companyUpdateObj = {
          ...companyUpdateObj,
          address: companyData.address,
        };
      if (fieldsUpdated.includes("cities"))
        companyUpdateObj = { ...companyUpdateObj, cities: companyData.cities };
      if (fieldsUpdated.includes("signal"))
        companyUpdateObj = {
          ...companyUpdateObj,
          is_signal: companyData.signal,
        };
      if (
        fieldsUpdated.includes("contact") ||
        fieldsUpdated.includes("contacts") ||
        fieldsUpdated.includes("removeContact")
      )
        companyUpdateObj = {
          ...companyUpdateObj,
          contacts: companyData.contacts,
        };
      try {
        setIsLoading(true);
        await axios.post(
          `/wp-json/api/v2/update_company/${companyData.id}`,
          companyUpdateObj
        );

        //update the cache:
        const tempCompanies = companies;
        let companyIndex = getCompanyIndex(tempCompanies, companyData.id);
        if (companyIndex > -1) {
          if (fieldsUpdated.includes("name"))
            tempCompanies[companyIndex].name = companyData.name;
          if (fieldsUpdated.includes("address"))
            tempCompanies[companyIndex].address = companyData.address;
          if (fieldsUpdated.includes("signal"))
            tempCompanies[companyIndex].is_signal = companyData.signal;
          if (fieldsUpdated.includes("cities"))
            tempCompanies[companyIndex].cities = companyData.cities;
          if (fieldsUpdated.includes("contact"))
            tempCompanies[companyIndex].contacts = companyData.contacts;
        }

        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        setError(err.response);
      }
    } else {
      //New Company
      setIsLoading(true);
      try {
        const newCompany = await axios.post("/wp-json/api/v2/company", {
          company_name: companyData.name,
          address: companyData.address,
          contacts: companyData.contacts,
          cities: companyData.cities,
          is_signal: companyData.signal,
        });
        setCompanies((prevCompanies) => [...prevCompanies, newCompany.data]);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        setError(err.response);
      }
    }
  };

  let showPagination = !isLoading ? (
    <MyPagination
      onChange={(event, page) => setCurrentPage(page)}
      totalPages={totalPages}
      currentPage={currentPage}
      total={totalCompaneis}
      totalLabel={"Total Companies"}
      //reload={handleReloadPage}
    />
  ) : null;

  return addMode ? (
    <AddUpdateCompanyManager
      onAddCompany={handleAddCompany}
      onClose={handleCancelAddCompany}
      company={companyToUpdate}
    />
  ) : (
    <React.Fragment>
      <Paper width={1} elevation={0} square className={classes.topSearchBar}>
        <div className={classes.topHeader}>
          <Grid
            container
            spacing={3}
            justify="flex-start"
            alignItems="center"
            style={{ margin: 0 }}
          >
            <Grid item xs={4} style={{ paddingRight: 0 }}>
              <MySearch
                searchLabel="Find Companies"
                helper={"Find company by name, id, location"}
              />
            </Grid>
            <Grid item xs={2}>
              <MySort />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={2}></Grid>
            <Grid
              item
              xs={3}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <IconButton
                aria-label="refresh"
                className={classes.refreshButton}
                color="primary"
              >
                <CachedRoundedIcon />
              </IconButton>
              <Button
                variant="contained"
                aria-label="add"
                color="primary"
                endIcon={<AddIcon />}
                onClick={() => props.history.push("/companies/add")}
              >
                Add Company
              </Button>
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    //onChange={this.handleShowDraftsOnly}
                    name="withSignal"
                    color="primary"
                  />
                }
                label="With Signal"
                //className={classes.checkbox}
              />
            </Grid>
            <Grid item xs={6}></Grid>
          </Grid>
        </div>
      </Paper>
      <Container maxWidth={"xl"} className={classes.root}>
        <Grid container spacing={2} className={classes.root}>
          <Grid item xs={12} style={{ maring: theme.spacing(2) }}>
            <Box my={1}>{showPagination}</Box>
            <Paper>
              {error && (
                <AxiosErrorHandling title={error.data.message} error={error} />
              )}
              {isLoading ? (
                <Spinner open={isLoading} />
              ) : (
                <Grid container>
                  <Grid
                    container
                    spacing={2}
                    justify="flex-start"
                    alignItems="center"
                  >
                    <Grid
                      item
                      //xs={shortVersion ? 12 : 2}
                      xs={2}
                    >
                      <div className={classes.row}>
                        <Typography variant="subtitle1" color="textSecondary">
                          COMPANY NAME
                        </Typography>
                      </div>
                    </Grid>

                    <React.Fragment>
                      <Grid item xs={1}>
                        <Typography variant="body1" color="textSecondary">
                          ID
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="body1" color="textSecondary">
                          Cities
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="body1" color="textSecondary">
                          Primary Contact
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="body1" color="textSecondary">
                          Contact Email
                        </Typography>
                      </Grid>
                      <Grid item xs={1}>
                        <Typography variant="body1" color="textSecondary">
                          Contact Mobile
                        </Typography>
                      </Grid>
                      <Grid item xs={1} style={{ textAlign: "center" }}>
                        <Typography variant="body1" color="textSecondary">
                          Signal
                        </Typography>
                      </Grid>
                      <Grid item xs={1} style={{ textAlign: "center" }}>
                        <Typography variant="body1" color="textSecondary">
                          Actions
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  </Grid>
                  <Divider />
                  {companies.map((company) => {
                    return (
                      <React.Fragment key={`${company.id}_${company.name}`}>
                        <SingleCompany
                          company={company}
                          onSelect={handleSelectCompany}
                          onRemove={(id) => setConfirmDelete(id)}
                          onShowSignals={handleShowSignalsTab}
                          onUpdate={handleUpdateCompany}
                          rerenderbit={rerender}
                        />
                        <Divider />
                      </React.Fragment>
                    );
                  })}
                </Grid>
              )}
            </Paper>
            <Box my={1}>{showPagination}</Box>
          </Grid>
        </Grid>
      </Container>
      {confirmDelete && confirmDelete > 0 && (
        <YesNoDialog
          open={true}
          onClose={() => setConfirmDelete(false)}
          title="Remove company"
          description={
            <div
              dangerouslySetInnerHTML={{
                __html: `Are you sure you want to delete company <b>${
                  companies.find((comp) => comp.id === confirmDelete).name
                }</b>? </br>This action is irreversable.`,
              }}
            />
          }
          positiveButtonLabel={"Yes"}
          onConfirm={handleRemoveCompany}
          negativeButtonLabel={"No"}
        />
      )}
      {selectedCompany > 0 && (
        <SingleCompanyFullDetails
          company={companies.find((company) => company.id === selectedCompany)}
          onClose={handleCloseFullDetails}
          onContactsRemove={handleContactsRemove}
          rerenderbit={rerender}
          initialTab={showSignalTab ? "signal" : "contacts"}
          onSignalUpdate={handleUpdateCompanySignals}
          signalCategories={signalCategories}
          onSave={handleSaveCompanySignals}
        />
      )}
    </React.Fragment>
  );
};

export default withRouter(CompaniesList);
